<template>
  <div class="header-warpper flex align-center">
    <div class="logo-box flex align-center justify-center">
      <img src="../assets/img/logo.png" alt="">
      <h3>三间有暖</h3>
    </div>

    <div class="flex-sub flex align-center justify-end user-info">
      <div class="flex align-center margin-right">
        <img src="../assets/img/avatar.png" alt="" class="margin-right-xs">
        <p class="font-size">{{ user.name }}</p>
      </div>
      <el-button type="primary"  size="small" class="font-size" @click="signOut">退出</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "header-modular",
  data() {
    return {}
  },
  computed:{
    user(){
      return this.$store.state.user
    }
  },
  created() {
  },
  methods: {
    signOut(){
      this.$confirm('您确定要退出吗？', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(() => {
        this.$store.state.user = null
        window.localStorage.clear()
        this.$router.replace('/login')
      })

    }
  },
}
</script>

<style scoped lang="scss">
.header-warpper {
  width: 100%;
  height: 75px;
  background: #fff;

  .logo-box {
    width: 260px;
    height: 75px;
    background-color: #f3b861;
    img{
      width: auto;
      width: 75px;
      margin-right: 10px;
    }
    h3{
      color: #fff;
      font-size: 16px;
      text-align: center;
      padding-right: 10px;
    }
  }

  .user-info {
    padding: 0 30px;
    height: 75px;
  }

}
</style>
